import { useOrgContext } from '@/contexts/orgContext';
import { UserInfo } from '@/lib/models';
import { axiosOrgService } from '@/lib/network';
import { Result } from '@/lib/type';
import { getCloudProviders, getPublicCloudProviders } from '@/pages/admin/settings/cloud_provider/api';
import { CloudProviderT } from '@/pages/admin/settings/cloud_provider/types';
import { isOrgAdmin } from '@/pages/admin/user/type';
import { AxiosError } from 'axios';
import { UseQueryOptions, useQuery } from 'react-query';

const LIST_POLL_INTERVAL_MS = 60000;
const ROLE_POLL_INTERVAL_MS = 15000;

export const useQueryCPs = (
  options?: Omit<UseQueryOptions<Result<CloudProviderT[]>, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<Result<CloudProviderT[]>, AxiosError>(['cloud-providers'], getCloudProviders, {
    refetchInterval: LIST_POLL_INTERVAL_MS,
    ...options,
  });
};

export const useQueryPublicCPs = () => {
  return useQuery<Result<CloudProviderT[]>, AxiosError>(['cloud-providers', 'public'], getPublicCloudProviders);
};

export const useCanManageCloudProviders = () => {
  const { userInfo } = useOrgContext();
  // Dedicated query key so this poll does not reuse ['profile'] from useProfile,
  // which fires trackLoginComplete on every successful fetch.
  const { data: profile } = useQuery<UserInfo, AxiosError>(
    ['cloud-provider-user'],
    async () => {
      const { data } = await axiosOrgService.get('/users/me');
      return data;
    },
    {
      refetchInterval: ROLE_POLL_INTERVAL_MS,
    }
  );

  return isOrgAdmin(profile?.roles ?? userInfo.roles);
};
